import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import './index.css';
import App from './App';
import HomeScreen from './components/screen/HomeScreen';
import NotFound from './components/screen/NotFound';
import { initIndexedDB } from './repository/note.repository';

// Import our new encryption service initializer
import { initEncryptionService } from './utils/crypto';

console.log('Application starting...');

const DEFAULT_STARTUP_ERROR_MESSAGE =
  'Could not connect to required services. Please try again later.';

const escapeHtml = (value) => String(value)
  .replaceAll('&', '&amp;')
  .replaceAll('<', '&lt;')
  .replaceAll('>', '&gt;')
  .replaceAll('"', '&quot;')
  .replaceAll("'", '&#039;');

const renderStartupError = (error) => {
  const errorMessage = escapeHtml(error?.message || DEFAULT_STARTUP_ERROR_MESSAGE);
  document.getElementById('root').innerHTML =
    '<div style="text-align: center; padding: 50px; font-family: sans-serif;">' +
    '<h1>Application Error</h1>' +
    `<p>${errorMessage}</p>` +
    '</div>';
};

// We now have two async tasks to run before the app is ready.
// Promise.all is perfect for this.
Promise.all([
  initIndexedDB(),
  initEncryptionService()
])
  .then(() => {
    console.log('✅ All services initialized. Rendering application.');
    const root = createRoot(document.getElementById('root'));
    root.render(
      <StrictMode>
        <RecoilRoot>
          <Router>
            <App>
              <Routes>
                <Route path="/" element={<HomeScreen />} />
                <Route path="*" element={<NotFound />} /> {/* Catch all route */}
              </Routes>
            </App>
          </Router>
        </RecoilRoot>
      </StrictMode>
    );
  })
  .catch((error) => {
    // Handle error if either service fails to initialize
    console.error("❌ CRITICAL: Failed to initialize application services. App cannot start.", error);
    renderStartupError(error);
  });



// Register the service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', function () {
    navigator.serviceWorker.register('/service-worker.js').then(function (registration) {
      console.log('Service Worker registration successful with scope: ', registration.scope);
    }, function (err) {
      console.log('Service Worker registration failed: ', err);
    });
  });
}
